













































































































import { Component, Vue } from "vue-property-decorator";
import UserAdd from "./modals/userAdd.vue";
import Ajax from '../..//lib/ajax';
import User from "@/store/entities/user";
@Component({
  components: { UserAdd },
})

export default class Users extends Vue {
  search: string = "";
  users: User[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  isOpenModal: boolean = false;

  async getUsers(){
    var response = await Ajax.get(
        '/api/services/app/User/GetAllUsers'
      );
      var data = response.data.result.items;
      this.users=data;
  }

  confirmDelete(item) {
    this.$swal({
      title: "Kayıt Silinecetir.",
      text: "İşlemi Devam Ettirmeye Emin misiniz?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Evet",
      cancelButtonText: "Hayır",
    }).then(async (result) => {
      if (result.isConfirmed) {
        
       await  Ajax.delete(
        '/api/services/app/User/Delete?id=' + item.id
      );

        Vue.$toast.success("Silme Başarılı");

        this.getUsers();
      }
    
    });
  }

  
  async created() {
    this.getUsers();
    (this.headers = [

      { text: "Kullanıcı Adı", value: "username" },
      { text: "Ad & Soyad", value: "name" },
      { text: "E-Posta", value: "email" },
      { text: "Şifre", value: "password" },
      { text: "İşlemler", value: "transactions" },

    ]),
      

    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Kullanıcılar", disabled: true },
    ];

    
  }


  // confirmDelete(item) {
  //   this.$swal({
  //     title: "Kayıt Silinecetir.",
  //     text: "İşlemi Devam Ettirmeye Emin misiniz?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Evet",
  //     cancelButtonText: "Hayır",
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       await this.deleteArticle(item);
  //       Vue.$toast.success("Silme Başarılı");
  //     }
  //   });
  // }


  data() {
    return {
      page: 1,
      pageCount: 0,
    
    };
  }
  

  cancelModal() {
    this.isOpenModal = false;

  }


  openModal() {
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.getUsers();
  }



}
